module.exports = __webpack_public_path__ + "img/17.8dc8b4af.png";